import {
  IS_ELIGIBLE_FOR_DELETE_REQUEST,
  CREATE_DELETE_REQUEST,
  GET_DELETE_REQUEST,
  CREATE_DATA_REQUEST,
  GET_DATA_REQUEST,
  CONFIRM_DATA_REQUEST
} from '@/utils/store/actionTypes'

export default {
  async [IS_ELIGIBLE_FOR_DELETE_REQUEST] ({ rootState }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/users/${rootState.auth.userId}/deletion-request/eligibility`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [GET_DELETE_REQUEST] ({ rootState }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/users/${rootState.auth.userId}/deletion-request`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [CREATE_DELETE_REQUEST] ({ rootState }) {
    const response = await this.$axios.$post(`${process.env.API_URL}/v2/users/${rootState.auth.userId}/deletion-request`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [CREATE_DATA_REQUEST] ({ rootState }) {
    const response = await this.$axios.$post(`${process.env.API_URL}/v2/users/${rootState.auth.userId}/data-request`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [GET_DATA_REQUEST] ({ rootState }) {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/users/${rootState.auth.userId}/data-request`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  },
  async [CONFIRM_DATA_REQUEST] ({ rootState }, { uuid, _hash }) {
    const response = await this.$axios.$post(`${process.env.API_URL}/v2/users/${rootState.auth.userId}/data-request/${uuid}/activate?_hash=${encodeURIComponent(_hash)}`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      }
    })

    return response
  }
}
